<template>
  <DBox
    :id="'cmp-distribution-statement-sidewindow-sales_details'"
    :addButton="false"
    :addLink="false"
  >
    <!-- @add_click="onAddArtist" -->
    <!-- :expandable="true" -->
    <NTable
      class="dbox1"
      id="distribution-statement-catalog"
      :config="tableConfig"
      :headers="Headers"
      :items="list"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('catalog_no')">
            <span class="txtov">{{ item['product_release_project_identifier'] }}</span>
          </td>
          <td v-bind="tdcon('identifier')">
            <span style="white-space: break-spaces" class="txtov">{{ item['identifier'] }}</span>
          </td>
          <td v-bind="tdcon('title1')">
            <span style="white-space: break-spaces"  class="txtov">{{ item['product_release_project_title'] }}</span>
          </td>
          <td v-bind="tdcon('type')">
            <span>{{ item['transaction_type_word'] }}</span>
          </td>
          <td v-bind="tdcon('shop')">
            <span style="white-space: break-spaces" class="txtov">{{ item['shop'] }}</span>
          </td>
          <td v-bind="tdcon('country')">
            <span>{{ getISO(item['country']) }}</span>
          </td>

          <td v-if="currentChannel!='performance'" v-bind="tdcon('ppd')">
            <span>{{ parseFloat(item['ppd']).toFixed(2) }}</span>
          </td>
          <td v-bind="tdcon('ppu')">
            <span>{{ parseFloat(item['ppu']).toFixed(2) }}</span>
          </td>
          <td v-bind="tdcon('qty')">
            <span>{{ item['quantity'] }}</span>
          </td>

          
          <!-- <td v-bind="tdcon('costs')">
            <span>{{ item['cost_pu'] }}</span>
          </td> -->
          <td v-bind="tdcon('total')">
            <span>{{ parseFloat(item['income']).toFixed(2) }}</span>
          </td>
          <td v-bind="tdcon('option')">
            <img
              src="static/icons/delete.svg"
              @click.stop="(e) => onDelete(item)"
              class="dt-icon v5 s2 ut-center"
              alt
            />
          </td>

        </tr>
      </template>
    </NTable>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";

export default {
  props: {
    selectedStatementDetails: {
      type: Object
    }
  },
  components: {
    NTable,
    DBox
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },

      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
        rowHeight: "auto",
        headerHeight: 32,
      })
    };
  },
  computed: {
    currentChannel:function(){
      return this.selectedStatementDetails?.statement?.digital_physical||'';
    },
    Headers: function() {
      let headers =[
        createTableHeader("catalog_no", { minw:120 , text:this.currentChannel=='physical'?this.$t('catalog_no'):this.$t('isrc')  }),
        createTableHeader("identifier", { minw:120 }),
        createTableHeader("title1", { text:this.$t('title') , minw:120}),
        createTableHeader("type", { mw:65,minw:65 }),
        createTableHeader("shop", { }),
        createTableHeader("country", { mw:60 , ta:'center'}),
        
        createTableHeader("ppd", { ta:'right'}),
        createTableHeader("ppu", { ta:'right'}),
        createTableHeader("qty", { ta:'right'}),
       
        //createTableHeader("costs", { ta:'right' ,text:this.$t('cost')}),
        createTableHeader("total", { ta:'right'}),
        createTableHeader("option", { text:false ,mw:30}),
        
      ];
      if(this.currentChannel=='performance'){
        headers = headers.filter(x=>x.value!='ppd')
      }

      return headers;


    },

    list: function() {
      return this.selectedStatementDetails.sales_details || [];
    },


  },
  methods: {
    onDelete:function(item){
      console.log(item)
      const { statement_line_id } = item;

      this.$emit('delete',{objKey:'sales_details' ,statement_line_id:statement_line_id ,statement_id:this.selectedStatementDetails.statement.statement_id})

    },
    getISO:function(value){
      // console.log("ARRR VALUE",value)
      if(value.includes("-")){
        const arr = value.split("-");
        return arr[1]
      }else{
        return value
      }

    },
    onClickItem:function(item){
      const { statement_line_id } = item;
      console.log()
      this.$router.push({
        ...this.$route,
        query: {
          modal: "manual_match_modal",
          statement_line_id:statement_line_id,
          channel:this.currentChannel
        }
      });
    }
  }
};
</script>
<style lang="scss">
.cmp-distribution-statement-sidewindow-sales_details {
  .dt-ntable tbody tr:last-child {
    border-bottom: 0;
  }
}
</style>